import React, { FC, useEffect } from 'react';
import { Layout, ConfigProvider } from 'antd';
import styled from 'styled-components';
import { isSales } from '~/utils/getDecodedJwt';
import { useInitApp } from './controllers/auth';
import Pages from './pages';
import TopBarLoader from './components/TopBarLoader';
import { useDirection, useGetAntdLocale, useGetAntdValidateMessages, useSetHtmlLang } from './hooks/i18nHooks';

const App: FC = () => {
  const locale = useGetAntdLocale();
  const direction = useDirection();
  const validateMessages = useGetAntdValidateMessages();
  useSetHtmlLang();

  const isAppReady = useInitApp();
  useEffect(() => {
    setTimeout(() => {
      const sales = isSales();
      localStorage.setItem('isSalesRole', `${!!sales}`);
    }, 3000);
  }, []);

  if (!isAppReady) return null;

  return (
    <ConfigProvider form={{ validateMessages }} locale={locale} direction={direction}>
      <StyledLayout className="App">
        <TopBarLoader />
        <Pages />
      </StyledLayout>
    </ConfigProvider>
  );
};

const StyledLayout = styled(Layout)`
  min-height: 100vh;
`;

export default App;
